// src/firebase-config.ts
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDwvk9fmIVotZWsm5CMhewyJkLITVpOn1o",
  authDomain: "cnctest-37477.firebaseapp.com",
  projectId: "cnctest-37477",
  storageBucket: "cnctest-37477.appspot.com",
  messagingSenderId: "310560473155",
  appId: "1:310560473155:web:170163d2faca5fc07f54f6",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
